<style scoped>
  .card-padding {
    padding: 30px;
  }
  .bullet {
    font-size: 60px;
  }
</style>

<template>
  <div>
    <v-card>
      <v-card-text class="card-padding">
        <p>First name</p>
        <p class="headline text--primary">{{ user.first_name }}</p>
        <p>Last name</p>
        <p class="headline text--primary">{{ user.last_name }}</p>
        <p>Email</p>
        <p class="headline text--primary">{{ user.email }}</p>
        <p>Password</p>
        <div class="d-flex">
          <span class="bullet text--primary">
            &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
          </span>
          <v-spacer />
          <div class="text-right" v-if="user.reset_password">
            <div class="error--text">System Password Expired</div>
            <div><small>This does not affect your gmail login credentials</small></div>
          </div>
          <v-btn
            v-else
            class="mr-3"
            text
            small
            color="primary"
            @click="showResetPasswordModal"
          >
            Change Password
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <reset-password-modal
      ref="resetPasswordModal"
      :requireOldPass="true"
    />
  </div>
</template>

<script>
import ResetPasswordModal from '@/components/admin/controls/users/forms/password/ResetPasswordModal';


export default {
  components: {
    ResetPasswordModal,
  },
  data: () => ({
    display: false,
    title: 'Change Password',
  }),
  computed: {
    user: vm => vm.$store.getters.user,
  },
  methods: {
    showResetPasswordModal() {
      this.$refs.resetPasswordModal.open(this.$utils.deepCopy(this.user));
    },
  },
  mounted() {
    if (this.$route.query.pwd === 'change') {
      this.showResetPasswordModal();
    }
  },
};
</script>
